import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiAddress\CreateWikiAddressController::__invoke
* @see app/Http/Controllers/WikiAddress/CreateWikiAddressController.php
* @route '/api/wiki-address'
*/
const CreateWikiAddressController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiAddressController.url(options),
    method: 'post',
})

CreateWikiAddressController.definition = {
    methods: ["post"],
    url: '/api/wiki-address',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\WikiAddress\CreateWikiAddressController::__invoke
* @see app/Http/Controllers/WikiAddress/CreateWikiAddressController.php
* @route '/api/wiki-address'
*/
CreateWikiAddressController.url = (options?: RouteQueryOptions) => {
    return CreateWikiAddressController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiAddress\CreateWikiAddressController::__invoke
* @see app/Http/Controllers/WikiAddress/CreateWikiAddressController.php
* @route '/api/wiki-address'
*/
CreateWikiAddressController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateWikiAddressController.url(options),
    method: 'post',
})

export default CreateWikiAddressController